// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── 내 정보 페이지 ── */
.profile-page {
  max-width: 860px;
  margin: 0 auto;
  padding: 22px 24px 32px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.profile-header h2 {
  margin: 0;
  color: #212529;
  font-size: 22px;
  font-weight: 700;
}

/* 뒤로가기 버튼 */
.profile-back {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
  color: #495057;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.profile-back:hover {
  background: #f1f3f5;
  border-color: #ced4da;
}

/* 상단 2단 그리드 (사용자 정보 · 담당자 색상) */
.profile-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 680px) {
  .profile-grid {
    grid-template-columns: 1fr;
  }
}

/* 카드 공통 */
.profile-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.profile-card-title {
  margin: 0 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f3f5;
  color: #343a40;
  font-size: 15px;
  font-weight: 700;
}

.profile-card-desc {
  margin: -6px 0 14px;
  color: #868e96;
  font-size: 13px;
}

/* 사용자 정보 — 컴팩트 key-value 목록 */
.profile-fields {
  margin: 0;
}

.profile-field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px dashed #f1f3f5;
}

.profile-field:last-child {
  border-bottom: none;
}

.profile-field dt {
  color: #868e96;
  font-size: 13px;
  flex-shrink: 0;
}

.profile-field dd {
  margin: 0;
  color: #212529;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}

/* ── 담당자 태그 색상 ── */
.tag-color-preview-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.tag-color-preview {
  color: #fff;
  padding: 0.28rem 0.65rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  forced-color-adjust: none;
}

.tag-color-code {
  color: #868e96;
  font-size: 13px;
  font-family: 'Consolas', monospace;
  text-transform: uppercase;
}

.tag-color-swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  align-items: center;
}

.tag-color-swatch {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid transparent;
  padding: 0;
  cursor: pointer;
  /* 전역 button 규칙(Login.css)이 남기는 보라 그라디언트를 제거해
     인라인 background-color(스와치 색)가 드러나도록 한다. */
  background-image: none;
  appearance: none;
  forced-color-adjust: none;
  background-clip: padding-box;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) inset;
  transition: transform 0.15s, box-shadow 0.15s;
}

.tag-color-swatch:hover:not(:disabled) {
  transform: scale(1.12);
}

.tag-color-swatch.selected {
  border-color: #fff;
  box-shadow: 0 0 0 2px #343a40, 0 2px 6px rgba(0, 0, 0, 0.2);
}

.tag-color-swatch:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.tag-color-custom {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px dashed #adb5bd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}

.tag-color-custom input[type="color"] {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  border: none;
  padding: 0;
}

.tag-color-custom-icon {
  font-size: 14px;
  pointer-events: none;
}

/* ── 비밀번호 변경 ── */
.profile-card-password .password-form {
  margin: 0;
}

.password-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 4px;
}

.password-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.profile-submit-btn {
  width: auto;
  background: #1971c2;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background 0.15s;
}

.profile-submit-btn:hover:not(:disabled) {
  background: #1864ab;
}

.profile-submit-btn:disabled {
  background: #adb5bd;
  cursor: not-allowed;
}

@media (max-width: 680px) {
  .profile-page {
    padding: 16px 14px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserProfile.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,eAAe;EACf;6CAC2C;EAC3C,sBAAsB;EAEtB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ── 내 정보 페이지 ── */\n.profile-page {\n  max-width: 860px;\n  margin: 0 auto;\n  padding: 22px 24px 32px;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.profile-header h2 {\n  margin: 0;\n  color: #212529;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n/* 뒤로가기 버튼 */\n.profile-back {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  background: #fff;\n  color: #495057;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.profile-back:hover {\n  background: #f1f3f5;\n  border-color: #ced4da;\n}\n\n/* 상단 2단 그리드 (사용자 정보 · 담당자 색상) */\n.profile-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 680px) {\n  .profile-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* 카드 공통 */\n.profile-card {\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 18px 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.profile-card-title {\n  margin: 0 0 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f1f3f5;\n  color: #343a40;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.profile-card-desc {\n  margin: -6px 0 14px;\n  color: #868e96;\n  font-size: 13px;\n}\n\n/* 사용자 정보 — 컴팩트 key-value 목록 */\n.profile-fields {\n  margin: 0;\n}\n\n.profile-field {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 9px 0;\n  border-bottom: 1px dashed #f1f3f5;\n}\n\n.profile-field:last-child {\n  border-bottom: none;\n}\n\n.profile-field dt {\n  color: #868e96;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.profile-field dd {\n  margin: 0;\n  color: #212529;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: right;\n  word-break: break-word;\n}\n\n/* ── 담당자 태그 색상 ── */\n.tag-color-preview-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.tag-color-preview {\n  color: #fff;\n  padding: 0.28rem 0.65rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  white-space: nowrap;\n  forced-color-adjust: none;\n}\n\n.tag-color-code {\n  color: #868e96;\n  font-size: 13px;\n  font-family: 'Consolas', monospace;\n  text-transform: uppercase;\n}\n\n.tag-color-swatches {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n  align-items: center;\n}\n\n.tag-color-swatch {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  padding: 0;\n  cursor: pointer;\n  /* 전역 button 규칙(Login.css)이 남기는 보라 그라디언트를 제거해\n     인라인 background-color(스와치 색)가 드러나도록 한다. */\n  background-image: none;\n  -webkit-appearance: none;\n  appearance: none;\n  forced-color-adjust: none;\n  background-clip: padding-box;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) inset;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.tag-color-swatch:hover:not(:disabled) {\n  transform: scale(1.12);\n}\n\n.tag-color-swatch.selected {\n  border-color: #fff;\n  box-shadow: 0 0 0 2px #343a40, 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.tag-color-swatch:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.tag-color-custom {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px dashed #adb5bd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.tag-color-custom input[type=\"color\"] {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n}\n\n.tag-color-custom-icon {\n  font-size: 14px;\n  pointer-events: none;\n}\n\n/* ── 비밀번호 변경 ── */\n.profile-card-password .password-form {\n  margin: 0;\n}\n\n.password-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 14px;\n  margin-bottom: 4px;\n}\n\n.password-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 14px;\n}\n\n.profile-submit-btn {\n  width: auto;\n  background: #1971c2;\n  color: #fff;\n  border: none;\n  padding: 10px 22px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background 0.15s;\n}\n\n.profile-submit-btn:hover:not(:disabled) {\n  background: #1864ab;\n}\n\n.profile-submit-btn:disabled {\n  background: #adb5bd;\n  cursor: not-allowed;\n}\n\n@media (max-width: 680px) {\n  .profile-page {\n    padding: 16px 14px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
